/* eslint-disable no-shadow */
/* eslint-disable implicit-arrow-linebreak */
import { Button, Checkbox, Col, Form, Input, InputNumber, Modal, notification, Popconfirm, Row, Select, Space, Tooltip } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import { schoolTypeCodeOption, skillOptions } from 'constants/optionCommon';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { formatDateTimeQuery } from 'constants/FormatString';
import { QuestionTypeData } from '../type';
import { delete_Category_QuestionType, insertUpdate_Category_QuestionType } from '../api';

type ModalStatusProps = {
  open: boolean;
  title: string;
  type: string;
};

type Props = {
  allData: QuestionTypeData[];
  selectedRecord: QuestionTypeData;
  onSuccess: any;
};

const InsertUpdate = ({ allData, selectedRecord, onSuccess }: Props) => {
  const [form] = Form.useForm();
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [formValues, setFormValues] = useState<any>(null);
  const [modalStatus, setModalStatus] = React.useState<ModalStatusProps>({
    open: false,
    title: '',
    type: '',
  });

  const isHiddenCreateFolder = Number(selectedRecord?.level) > 1;
  const hiddenEditAndRemove = selectedRecord?.children && selectedRecord?.children?.length > 0;
  const parentOption = allData?.filter((i: any) => (!i.parentId || i.parentId === '00000000-0000-0000-0000-000000000000') && i.schoolType === formValues?.schoolType).map((i: any) => ({ label: i.questionTypeName, value: i.id }));

  const handleVisibleModal = (type: 'add' | 'edit' | 'close' | 'save_success') => {
    if (type === 'add') {
      setModalStatus({
        title: 'TẠO MỚI',
        open: true,
        type,
      });
      const value: any = {
        schoolType: selectedRecord?.schoolType,
        parentId: selectedRecord?.id,
        questionTypeName: '',
        questionTypeCode: '',
        subTypeName: '',
        componentType: '',
        sortOrder: 0,
        skills: null,
      };
      form.setFieldsValue(value);
      setFormValues(value);
    } else if (type === 'edit') {
      const value: any = {
        schoolType: selectedRecord.schoolType,
        parentId: selectedRecord.parentId,
        questionTypeName: selectedRecord.questionTypeName,
        questionTypeCode: selectedRecord.questionTypeCode,
        subTypeName: selectedRecord.subTypeName,
        componentType: selectedRecord.componentType,
        sortOrder: selectedRecord.sortOrder,
        skills: selectedRecord.skill ? selectedRecord?.skill?.split(',') : null,
      };
      form.setFieldsValue(value);
      setFormValues(value);
      setModalStatus({
        title: 'CẬP NHẬT',
        open: true,
        type,
      });
    } else if (type === 'close') {
      setModalStatus({
        title: '',
        open: false,
        type,
      });
    } else if (type === 'save_success') {
      onSuccess();
      setModalStatus({
        title: '',
        open: false,
        type,
      });
    }
  };

  const onUpdateParent = (parentId: any, params: any) =>
    // eslint-disable-next-line no-async-promise-executor
    new Promise(async (resolve, reject) => {
      const findParent = allData.find((item) => item.id === parentId);
      if (!findParent) {
        return reject(new Error('Không tìm thấy cấp cha'));
      }
      let newSkills = params.Skill;
      await allData.forEach((item) => {
        if (item.parentId === parentId && item.id !== params.Id && item.skill) {
          const skills = item.skill
            ?.split(',')
            .filter((i: string) => !newSkills.includes(i))
            .toString();
          if (skills && skills.length > 0) {
            newSkills = `${newSkills},${skills}`;
          }
        }
      });
      await insertUpdate_Category_QuestionType({
        Id: findParent.id,
        ComponentType: findParent.componentType,
        Notes: findParent.notes,
        CreatedDate: findParent.createdDate,
        ModifiedDate: findParent.modifiedDate,
        QuestionTypeCode: findParent.questionTypeCode,
        QuestionTypeName: findParent.questionTypeName,
        SchoolType: findParent.schoolType,
        SubTypeName: findParent.subTypeName ?? '',
        ParentId: findParent.parentId ?? '00000000-0000-0000-0000-000000000000',
        SortOrder: findParent.sortOrder,
        Skill: newSkills,
      });
      return resolve('done');
    });

  // eslint-disable-next-line consistent-return
  const handleUpdateParent = (params: any) => {
    if (params.ParentId === '00000000-0000-0000-0000-000000000000') {
      setIsProcessing(false);
      return 'Không cần cập nhật';
    }
    // Không thay đổi skill và parent
    // if (modalStatus.type === 'edit' && params.ParentId === selectedRecord?.parentId && params.Skill === selectedRecord?.skill) {
    //   setIsProcessing(false);
    //   return 'Không cần cập nhật';
    // }

    // update cấp cha mới của "Yêu cầu đề bài" hiện tại
    const promises = [onUpdateParent(params.ParentId, params)];
    // Update cấp cha cũ nếu có
    if (modalStatus.type === 'edit' && selectedRecord?.parentId !== params.ParentId) {
      promises.push(onUpdateParent(selectedRecord?.parentId, params));
    }
    Promise.allSettled(promises).then((results) => {
      setIsProcessing(false);
      handleVisibleModal('save_success');
    });
  };

  const onInsertUpdate = async (formValues: any) => {
    if (!isProcessing) {
      try {
        await setIsProcessing(true);
        const { schoolType, parentId, questionTypeName, subTypeName, questionTypeCode, componentType, skills, sortOrder } = formValues;
        const timeNow = moment().format(formatDateTimeQuery);
        let params: any;
        if (modalStatus.type === 'add') {
          params = {
            Id: '00000000-0000-0000-0000-000000000000',
            ComponentType: componentType?.toUpperCase() ?? '',
            Notes: '',
            CreatedDate: timeNow,
            ModifiedDate: timeNow,
            QuestionTypeCode: questionTypeCode.toUpperCase(),
            QuestionTypeName: questionTypeName,
            SchoolType: schoolType,
            SubTypeName: subTypeName ?? '',
            ParentId: parentId ?? '00000000-0000-0000-0000-000000000000',
            SortOrder: sortOrder,
            Skill: skills ? skills.toString() : '',
          };
        } else if (modalStatus.type === 'edit') {
          params = {
            Id: String(selectedRecord.id),
            ComponentType: componentType?.toUpperCase() ?? '',
            Notes: selectedRecord.notes,
            CreatedDate: selectedRecord.createdDate,
            ModifiedDate: timeNow,
            QuestionTypeCode: questionTypeCode.toUpperCase(),
            QuestionTypeName: questionTypeName,
            SchoolType: schoolType,
            SubTypeName: subTypeName ?? '',
            ParentId: parentId ?? '00000000-0000-0000-0000-000000000000',
            SortOrder: sortOrder,
            Skill: skills ? skills.toString() : '',
          };
        }
        if (!params) {
          setIsProcessing(false);
          return;
        }
        insertUpdate_Category_QuestionType(params)
          .then((res) => {
            notification.success({
              message: 'Thành công',
              description: 'Lưu dữ liệu thành công!',
            });
            handleUpdateParent(params);
          })
          .catch((err) => {
            notification.error({
              message: 'Thất bại',
              description: 'Lưu dữ liệu thất bại!',
            });
            setIsProcessing(false);
          });
      } catch (error) {
        notification.error({
          message: 'Thất bại',
          description: 'Lưu dữ liệu thất bại!',
        });
        setIsProcessing(false);
      }
    }
  };

  const onDeleteFolder = async (id: any) => {
    delete_Category_QuestionType(id)
      .then((res) => {
        notification.success({
          message: 'Thành công',
          description: 'Xoá dữ liệu thành công!',
        });
        onSuccess();
      })
      .catch((err) => {
        notification.error({
          message: 'Thất bại',
          description: 'Xoá dữ liệu thất bại!',
        });
      });
  };

  const onFormValuesChange = (changedValues: any, values: any) => {
    setFormValues(values);
    if (changedValues.schoolType) {
      form.setFieldValue('parentId', null);
    }
  };

  const validateTypeName = (_: any, value: string) => {
    if (value?.trim()) {
      if (
        allData.some(
          (i) =>
            // điều kiện tạo mới hoặc chỉnh sửa
            (i.id !== selectedRecord?.id || modalStatus.type === 'add') &&
            // không được trùng
            i.questionTypeName === value &&
            // Khác cấp học được trùng
            i.schoolType === form.getFieldValue('schoolType'),
        )
      ) {
        return Promise.reject(new Error('Tiêu đề đã tồn tại'));
      }
    }
    return Promise.resolve();
  };

  return (
    <>
      <Space wrap>
        {!isHiddenCreateFolder && (
          <Button
            type='dashed'
            shape='circle'
            onClick={() => {
              handleVisibleModal('add');
            }}
            icon={<PlusOutlined />}
          />
        )}
        <Tooltip title={!selectedRecord && 'Vui lòng chọn danh mục'} placement='topRight'>
          <Button
            type='dashed'
            shape='circle'
            icon={<EditOutlined />}
            onClick={() => {
              handleVisibleModal('edit');
            }}
            disabled={!selectedRecord}
          />
        </Tooltip>
        {!hiddenEditAndRemove && (
          <Popconfirm placement='topLeft' title={`Bạn có chắc muốn xóa ${''}?`} onConfirm={() => onDeleteFolder(selectedRecord?.id)} okText='OK' cancelText='Đóng'>
            <Tooltip title={!selectedRecord && 'Vui lòng chọn danh mục'} placement='topRight'>
              <Button danger type='dashed' shape='circle' icon={<DeleteOutlined />} disabled={!selectedRecord} />
            </Tooltip>
          </Popconfirm>
        )}
      </Space>

      {/* MODAL */}
      <Modal
        title={modalStatus.title}
        open={modalStatus.open}
        centered
        cancelText='Đóng'
        onCancel={() => handleVisibleModal('close')}
        okText='Lưu'
        onOk={() => form.submit()}
        okButtonProps={{
          loading: isProcessing,
        }}
        bodyStyle={{ paddingBottom: 0 }}
      >
        <Form form={form} onFinish={onInsertUpdate} layout='vertical' onValuesChange={onFormValuesChange}>
          <Row gutter={[12, 12]}>
            <Col span={12}>
              <Form.Item name='schoolType' label='Cấp học' rules={[{ required: true, message: 'Chưa nhập cấp học' }]}>
                <Select options={schoolTypeCodeOption} getPopupContainer={(trigger) => trigger.parentElement} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name='parentId' label='Cấp cha'>
                <Select options={parentOption} getPopupContainer={(trigger) => trigger.parentElement} disabled={!formValues?.schoolType} allowClear />
              </Form.Item>
            </Col>
            {formValues?.parentId ? (
              <>
                <Col span={24}>
                  <Form.Item name='questionTypeName' label='Tiêu đề bài tập' rules={[{ required: true, whitespace: true, message: 'Chưa nhập tiêu đề' }, { validator: validateTypeName }]}>
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name='subTypeName' label='Tiêu đề (tiếng việt)'>
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name='componentType' label='Mã loại bài tập' rules={[{ required: true, whitespace: true, message: 'Chưa nhập mã loại bài tập' }]}>
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name='questionTypeCode' label='Mã kiểu đáp án' rules={[{ required: true, whitespace: true, message: 'Chưa nhập kiểu đáp án' }]}>
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name='skills' label='Kĩ năng' rules={[{ required: true, message: 'Chưa nhập kĩ năng' }]}>
                    <Checkbox.Group options={skillOptions} />
                  </Form.Item>
                </Col>
              </>
            ) : (
              <>
                <Col span={24}>
                  <Form.Item name='questionTypeName' label='Tên loại bài tập' rules={[{ required: true, whitespace: true, message: 'Chưa nhập tiêu đề' }, { validator: validateTypeName }]}>
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name='questionTypeCode' label='Mã loại bài tập:' rules={[{ required: true, whitespace: true, message: 'Chưa nhập loại bài tập' }]}>
                    <Input />
                  </Form.Item>
                </Col>
              </>
            )}
            <Col>
              <Form.Item name='sortOrder' label='Thứ tự' rules={[{ required: true, message: 'Chưa nhập thứ tự' }]}>
                <InputNumber min={1} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default InsertUpdate;
